import { select, call, put, takeLatest } from 'redux-saga/effects';
import { handleError } from '../sagas/error';
import { getApi } from '../sagas/api';
import {
    GET_CUSTOMERS_WITHOUT_EMPLOYEE,
    getCustomersWithoutEmployeeError,
    getCustomersWithoutEmployeeSuccess,
} from './actions';
import { apiKeySelector } from '../auth/selectors';

function* getCustomersWithoutEmployee() {
    try {
        const token = yield select(apiKeySelector);
        const data = yield call(getApi, token, '/customers/withoutemployee');
        yield put(getCustomersWithoutEmployeeSuccess(data));
    } catch (error) {
        yield put(getCustomersWithoutEmployeeError(error));
        yield handleError(error);
    }
}

export default [takeLatest(GET_CUSTOMERS_WITHOUT_EMPLOYEE, getCustomersWithoutEmployee)];
